import { useEffect, useState } from "react";
import CalendarComponent from "../components/CalendarComponent";
import useAxios from "../../../Utils/useAxios";
import getRealokasi from "../services/getRealokasi";
import getTransaksi from "../services/getTransaksi";
import getUMK from "../services/getUMK";
import getUMO from "../services/getUMO";
import {
  realokasiMap,
  transaksiMap,
  umkMap,
  umoMap,
} from "../constants/FeatureMaps";
import getUnitKerja from "../services/getUnitKerja";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";

const CalendarContain = () => {
  const axiosInstance = useAxios();

  const [transaksi, setTransaksi] = useState([]);
  const [realokasi, setRealokasi] = useState([]);
  const [umk, setUMK] = useState([]);
  const [umo, setUMO] = useState([]);

  const [transaksiData, setTransaksiData] = useState([]);
  const [realokasiData, setRealokasiData] = useState([]);
  const [umkData, setUMKData] = useState([]);
  const [umoData, setUMOData] = useState([]);

  const [unitKerja, setUnitKerja] = useState([]);

  useEffect(() => {
    const fetchData = () => {
      getTransaksi(axiosInstance).then((resData) => {
        console.log("transaksi", resData);
        setTransaksi(resData);
        setTransaksiData(resData.map(transaksiMap));
      });

      getRealokasi(axiosInstance).then((resData) => {
        console.log("realokasi", resData);
        setRealokasi(resData);
        setRealokasiData(resData.map(realokasiMap));
      });

      getUMK(axiosInstance).then((resData) => {
        console.log("umk", resData);
        setUMK(resData);
        setUMKData(resData.map(umkMap));
      });

      getUMO(axiosInstance).then((resData) => {
        console.log("umo", resData);
        setUMO(resData);
        setUMOData(resData.map(umoMap));
      });

      getUnitKerja(axiosInstance).then((resData) => {
        console.log("unitkerja", resData);
        setUnitKerja(resData);
      });
    };

    fetchData();
  }, []);

  console.log("data", {
    transaksi: transaksiData,
    realokasi: realokasiData,
    umk: umkData,
    umo: umoData,
  });

  return (
    <FeatureContainer title={"Kalender"}>
      <CalendarComponent
        data={{
          transaksi: transaksi,
          realokasi: realokasi,
          umk: umk,
          umo: umo,
        }}
        events={{
          transaksi: transaksiData,
          realokasi: realokasiData,
          umk: umkData,
          umo: umoData,
        }}
        unitKerja={unitKerja}
      />
    </FeatureContainer>
  );
};

export default CalendarContain;
